<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="$router.push('add')">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          row-key="id"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column prop="num" :label="$t('编号')" fixed />
        <el-table-column prop="name" :label="$t('名称')" fixed />
        <el-table-column :label="$t('更新时间')">
          <template  v-slot="{row}">
            {{row.updateTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="50">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('detail?code=' + row.code)">{{$t('查看')}}</el-link>
              <el-link type="primary" :underline="false" @click="$router.push('edit?code=' + row.code)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "RichTextList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.richText.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.richText.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.richText.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
